module.exports = __webpack_public_path__ + "static/media/mainHeroWave.aea4063c.svg";